import {Component, OnInit, OnDestroy, Output, EventEmitter} from '@angular/core';
import {AppComponent} from "../../app.component";
import {SharedDataService} from "../../services/shared-data.service";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {ApiService} from "../../api.service";
import {SubscriptionLike} from "rxjs/index";
import {ListItem} from "../../objects/listItem";
import {AppEvent} from "../../objects/appEvent";
import {FS3Notification} from "../../objects/notification";
import {moveItemInArray, transferArrayItem} from "@angular/cdk/drag-drop";
import {DialogCanvasComponent} from "../dialog-canvas/dialog-canvas.component";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {NavigationItem} from "../../objects/navigationItem";
import {environment} from "../../../environments/environment";
import {labels} from "../../../locale/labels";

@Component({
  selector: 'app-article-view',
  templateUrl: './article-view.component.html',
  styleUrls: ['./article-view.component.scss','./../../app.component.scss','./../listing/listing.component.scss']
})
export class ArticleViewComponent implements OnInit, OnDestroy {

  public listItem: ListItem;
  public itemVsCourseData: object;
  public articleData: object;
  public owner_picture: string;
  public owner_name: string;
  public owner_role: string;
  public company_team: string = labels[AppComponent.appLang]['team']+' '+environment['company_label'];
  public courseNavigation: object[];
  public titleItemIdx: number = 0;
  public openedMenuItemIdx: number = 0;
  public articleMode: string;
  private sharedEventSubscription: SubscriptionLike;

  constructor(
    private activeRoute: ActivatedRoute,
    private apiService: ApiService,
    public router: Router,
    public dialog: MatDialog,
    private sharedDataService: SharedDataService,
    public application: AppComponent,
  ) {
  }

  ngOnInit(): void {
    this.sharedEventSubscription = this.sharedDataService.globalEventObservable$.subscribe(
      appEvent => {
        if (appEvent.type === AppEvent.APP_STATE_CHANGE) {
          let stateData = appEvent.data;
          if(stateData['newState'] == 'article_item_edit') {
            this.articleMode = 'edit';
            this.updateNavigationMenuForArticleItem();
            // let folderUUID = this.router.url.split('/')[3]
            // let articleUUID = this.router.url.split('/')[4]
            // this.addEditArticleNavigationItem(folderUUID,articleUUID) //todo
          }
          if(stateData['newState'] == 'article_item' && stateData['oldState'] == 'article_item_edit') {
            this.articleMode = '';
            this.updateNavigationMenuForArticleItem();
            // let folderUUID = this.router.url.split('/')[3]
            // let articleUUID = this.router.url.split('/')[4]
            // this.addEditArticleNavigationItem(folderUUID,articleUUID) //todo
          }
        }
        // if (appEvent.type === AppEvent.EDIT_ARTICLE_ITEM) {
        //   let folderUUID = this.router.url.split('/')[3]
        //   let articleUUID = this.router.url.split('/')[4]
        //   this.router.navigateByUrl('/articles/item/'+folderUUID+'/'+articleUUID+'/edit');
        //   this.application.state = 'article_item_edit'
        //   this.articleMode = 'edit';
        //   //this.addEditArticleNavigationItem(folderUUID,articleUUID) //todo
        // }
        if (appEvent.type === AppEvent.SAVE_ARTICLE_ITEM) {
          let folderUUID = this.router.url.split('/')[3]
          let articleUUID = this.router.url.split('/')[4]
          this.application.apiService
            .updateArticleItem(this.application.user.magic_key,articleUUID,folderUUID,this.articleData)
            .subscribe(
              data => {
                let notification = new FS3Notification();
                notification.type = 'success';
                notification.text = 'Updated';
                this.sharedDataService.pushNotification(notification);

                this.router.navigateByUrl('/articles/item/'+folderUUID+'/'+articleUUID);
                this.application.state = 'article_item'
                this.articleMode = '';
                this.application.dirtyArticleEdit = false
              },
              error => {
                const { exception } = error;
                if (exception && exception.error && exception.error.message) {
                  let notification = new FS3Notification();
                  notification.type = 'error';
                  notification.text = exception.error.message;
                  this.sharedDataService.pushNotification(notification);
                }
              }
            )
        }
      });
    this.getArticleItem();
  }
  ngOnDestroy() {
    this.sharedEventSubscription.unsubscribe();
  }

  getArticleItem(alias = null) {
    switch (this.application.state) {
      case 'static_article':
        //let staticAlias = alias ? alias : this.router.url.split('/')[3]
        let staticAlias = alias ? alias : this.router.url.split('/').pop()
        console.log('staticAlias',staticAlias)
        //todo: no this.application.user.magic_key at this component state
        this.apiService.getStaticArticle(staticAlias, this.application.user ? this.application.user.magic_key : '')
          .subscribe(
            data => this.handleItem(data),
            error => this.handleItemsError(error))
        break;
      case 'article_item':
      case 'article_item_edit':
        //this.router.url.split('/')[2]
        let folderUUID = this.router.url.split('/')[3]
        let articleUUID = this.router.url.split('/')[4]
        this.articleMode = this.router.url.split('/')[5]
        console.log('folderUUID',folderUUID,'articleUUID')
        this.apiService.getArticleCourse(folderUUID, articleUUID, AppComponent.user ? AppComponent.user.magic_key : '')
          .subscribe(
            data => this.handleItem(data),
            error => this.handleItemsError(error))
        break;
    }
  }

  public titleIdx = 0;
  private handleItem(data) {
    this.listItem = data['articleItem'];
    this.itemVsCourseData = data;
    this.articleData = JSON.parse(this.listItem.itemFullData['data']);
    this.owner_picture = data['ownerProfile']['picture_src_preview'];
    this.owner_name = data['ownerProfile']['shipping_name'];
    this.owner_role = data['ownerProfile']['native_group']['status'];
    this.courseNavigation = data['courseNavigation'];
    if(this.courseNavigation) {
      for (let i = 0; i < this.courseNavigation.length; i++) {
        let category = this.courseNavigation[i];
        let articleFound = false;
        category['articles'].map(articleItem => {
          if(this.listItem['itemFullData']['static_html_alias'] === articleItem['static_html_alias']) {
            articleFound = true;
          }
        })
        if(articleFound) {
          this.openedMenuItemIdx = i;
          break;
        }
      }
    }

    this.updateNavigationMenuForArticleItem();
    //console.log('handleItem',data,this.articleData)
    //this.application.debugMode = true;
  }

  private updateNavigationMenuForArticleItem() {
    this.application.setArticlesFoldersNavigation();
    let openedFolderNavigationItem = new NavigationItem();
    openedFolderNavigationItem.route = '/articles/folder/'+this.itemVsCourseData['folderUUID'];
    openedFolderNavigationItem.label = this.itemVsCourseData['folderName'];
    this.application.addNavigationItem(openedFolderNavigationItem)

    let openedArticleNavigationItem = new NavigationItem();
    openedArticleNavigationItem.route = '/articles/item/'+this.itemVsCourseData['folderUUID']+'/'+this.itemVsCourseData['articleItem']['itemFullData']['uuid'];
    openedArticleNavigationItem.label = 'item'; //todo obtain article item name
    this.application.addNavigationItem(openedArticleNavigationItem)

    if(this.articleMode == 'edit') {
      this.addEditArticleNavigationItem(this.itemVsCourseData['folderUUID'],this.itemVsCourseData['articleItem']['itemFullData']['uuid'])
    }
  }
  private addEditArticleNavigationItem(folderUUID,uuid) {
    let editArticleNavigationItem = new NavigationItem();
    editArticleNavigationItem.route = '/articles/item/'+folderUUID+'/'+uuid+'/edit';
    editArticleNavigationItem.label = 'edit';
    this.application.addNavigationItem(editArticleNavigationItem)
  }

  public linkClick(link) {
    window.open(link, '_blank')
  }

  public handleMenuClick(articleItem) {
    if(this.application.user && this.application.user.id) {
      if(!articleItem['static_html_alias']) {
        //todo
        const note = new FS3Notification();
        note.type = 'error';
        note.text = 'This article has no address.';
        this.sharedDataService.pushNotification(note)
        return;
      }
      this.listItem = null;
      this.articleData = null;
      //this.courseNavigation = null;
      //this.openedMenuItemIdx = 0;
      //no page refresh!
      this.application.router.navigateByUrl('/articles/'+articleItem['static_html_alias']);
      this.getArticleItem(articleItem['static_html_alias']);
    } else {
      if(articleItem['static_html_alias'] && articleItem['uuid']) {
        //window['location']['href'] = '/' + AppComponent.appLang + '/articles/'+articleItem['uuid']+'/'+articleItem['static_html_alias'];
        window['location']['href'] = '/'+AppComponent.appLang+'/r_articles/'+environment['gid']+'/'+AppComponent.appLang+'/'+articleItem['uuid']+'/'+articleItem['static_html_alias'];
      } else {
        let appEvent = new AppEvent(AppEvent.SHOW_LOGIN_FROM_STATIC_ARTICLE, null);
        this.sharedDataService.pushAppEvent(appEvent)
      }
    }
  }

  public addItem(event, idx) {
    let articleItem = {type: 'title', value: ''};
    this.articleData['article'].splice(idx+1, 0, articleItem);
    this.editItem(event, idx+1, 'insert')
  }
  public editItem(event, idx, mode = 'edit') {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      //...this.commonDialogConf,
      height: '50%',
      minHeight: '50%',
      minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '90%' : '65%',
      data: {
        application: this.application,
        state: 'article-item-edit',
        payload: {
          articleData: this.articleData,
          idx: idx,
          mode: mode,
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((confirmed) => {
        console.log('confirmed',confirmed,idx,mode);
        if (!confirmed && mode === 'insert') { //remove unsaved new item
          this.articleData['article'].splice(idx, 1);
        }
      })
  }
  public moveDownItem(event, idx) {
    this.application.dirtyArticleEdit = true
    moveItemInArray(this.articleData['article'],idx,idx+1);
  }
  public moveUpItem(event, idx) {
    this.application.dirtyArticleEdit = true
    moveItemInArray(this.articleData['article'],idx,idx-1);
  }
  public deleteItem(event, idx) {
    const dialogRef = this.dialog.open(DialogCanvasComponent, {
      //...this.commonDialogConf,
      height: 'auto',
      data: {
        application: this.application,
        state: 'article-item-delete',
        payload: {
          articleData: this.articleData,
          idx: idx,
        }
      }
    } as MatDialogConfig);
    dialogRef.addPanelClass('common-dialog');
    dialogRef.addPanelClass('common-dialog-medium-form');
    dialogRef.afterOpened().subscribe(() => {
      (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    })
    dialogRef.afterClosed()
      .subscribe((confirmed) => {
        if(confirmed) {
          this.application.dirtyArticleEdit = true
          transferArrayItem(this.articleData['article'],[],idx,0);
        }
    })
  }

  private handleItemsError({ errMsg, exception: { status } }) {
    // if (status === 401) {
    //   this.logout.emit({ isExpired: true });
    //   return
    // }

    if (errMsg) {
      this.sharedDataService.pushNotification({ text: errMsg, type: 'error' })
    }
  }

}
